export const STYLES = {
  swiperSlide:
    'flex flex-col bg-charcoal-50 text-charcoal-900 mx-auto max-w-[39rem]',
  formStepTitle:
    'text-3xl font-medium mb-4 text-pretty text-charcoal-800 font-serif',
};

export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 12,
  SPECIAL_CHARACTERS: /[!@#$%^&*(),.?":{}|<>]/,
  MAX_FIELD_LENGTH: 100,
  MAX_NAME_LENGTH: 50,
  MAX_PHONE_LENGTH: 50,
};

export const BOOKING_METHOD_OPTIONS = [
  'Pen and paper',
  'Other software',
  'Walk-ins',
  "I'm a new business",
];
